export default "__VITE_ASSET__CDQ03MMf__"